import React, { useEffect } from 'react';
import { ContactInfo } from './ContactInfo';
import { Error } from '@pec/aion-ui-components/components/Error';
import { fetchTrainee } from 'features/trainee/slice';
import { fetchTraineeCourseCredits, traineeCourseCreditsSelectors } from 'features/traineeCourseCredits/slice';
import { fetchUserInfoIfNeeded } from '@pec/aion-ui-core/actions/userInfo';
import { getOptionsIfNeeded } from '@pec/aion-ui-core/actions/options';
import { Loading } from '@pec/aion-ui-components/components/Loading';
import { Route, Switch } from 'react-router-dom';
import { TrainingHistory } from './TrainingHistory';
import { useAppDispatch, useTypedSelector } from 'app/reducer';
import { UserPrompt } from './UserPrompt';

export const Profile: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isFetching: isFetchingTrainee, error: traineeError, trainee, count: traineeCount } = useTypedSelector(
    state => state.trainee
  );
  const { userInfo, isFetching: isFetchingUserInfo, error: userInfoError } = useTypedSelector(state => state.userInfo);
  const { isFetching: isFetchingTraineeCourseCredits, error: traineeCourseCreditsError } = useTypedSelector(
    state => state.traineeCourseCredits
  );
  const traineeCourseCredits = useTypedSelector(traineeCourseCreditsSelectors.selectAll);

  const isFetching = isFetchingTrainee || isFetchingTraineeCourseCredits || isFetchingUserInfo;
  const error = traineeError || traineeCourseCreditsError || userInfoError;

  useEffect(() => {
    dispatch(getOptionsIfNeeded());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchUserInfoIfNeeded());
  }, [dispatch]);

  useEffect(() => {
    if (userInfo) {
      dispatch(fetchTrainee(userInfo.userId));
      dispatch(fetchTraineeCourseCredits(userInfo.userId));
    }
  }, [dispatch, userInfo]);

  return !isFetching ? (
    trainee && traineeCourseCredits && !error ? (
      <Switch>
        <Route
          exact
          path="/"
          render={() => <TrainingHistory trainee={trainee} traineeCourseCredits={traineeCourseCredits} />}
        />
        <Route
          exact
          path="/contact-info"
          render={() => <ContactInfo trainee={trainee} traineeCourseCredits={traineeCourseCredits} />}
        />
      </Switch>
    ) : trainee === undefined ? (
      <UserPrompt isRegistered={traineeCount === 1} />
    ) : (
      error && <Error />
    )
  ) : (
    <Loading />
  );
};
